<template>
    <select class="custom-select shadow-sm" v-model="selectedBank" :disabled="disabled" :required="required">
        <option :value="null" disabled selected>Select a bank</option>
        <option v-for="bank in banks" :value="bank.id">{{ bank.name }}</option>
    </select>
</template>

<script>
	export default {
		data() {
			return {
				error: null,
				disabled: false,
				required: true,
				selectedBank: null,
				banks: null
			};
		},
		created() {
			this.fetchBanks();
		},
		watch: {
			selectedBank: function(bank) {
				this.$emit("change-bank", bank);
			}
		},
		methods: {
			fetchBanks() {
				this.error = this.banks = null;
				this.disabled = true;

				axios
					.get("/api/banks")
					.then(response => {
						this.banks = response.data.data.banks;
						this.selectedBank = this.bank;
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.disabled = false;
					});
			}
		},
		props: ["bank"]
	};
</script>